export default "__VITE_ASSET__Ew5GhByD__"